@if (!isEmpty) {
  <div class="table-header table-header-offset-sm table-header-with-controls">
    <div class="table-header-controls">
      <button
        rktButton
        appRemoveFocus
        btnType="primary"
        title="Add a Beneficial Owner"
        (click)="onAddBeneficiaryBtnClick(holderId)"
        class="add-entity-btn"
        [disabled]="!!(loading | accessControl | async)"
      >
        <rkt-icon name="plus"></rkt-icon>
        Add a Beneficial Owner
      </button>
    </div>
  </div>
}
